<template>
    <div>
      <h1>{{this.$route.params.titulo}}</h1>
      <v-tabs class="mt-2 mb-2"  bg-color="#FFF">
        <v-tabs-slider color="#fff"></v-tabs-slider>
        <v-tab @click="voltar" color="#fff" >
          <v-icon left color="#757575">arrow_back</v-icon>
        </v-tab>
      </v-tabs>
      <DataGrid
        :colunas="colunas"
        :urlPagina="urlPagina"
        :ordemGrid="ordemGridt"
        :filtroGrid="filtroGridt"
        :queryParams="queryParams"
      >
      </DataGrid>
    </div>
</template>

<script>
import DataGrid from '@/components/DataGrid'
export default {
    name: 'tabelaSimples',
    components: {
      DataGrid
    },
    props: {
      ordemGrid:{
				type: Boolean,
				default: true
      },
      filtroGrid:{
				type: Boolean,
				default: true
			},
      queryParams: {
        type: String,
        default: ''
      }
    },
    data(){
      return{
        colunas: this.$route.params.headers,
        urlPagina: this.$route.params.rota_api,
        ordemGridt: this.$route.params.ordemGrid,
        filtroGridt: this.$route.params.filtroGrid
      }
    },
    methods:{
      voltar(){
        this.$root.$router.go(-1)
      }
    }
}
</script>

<style>

</style>
